import styled from '@emotion/styled';
import { Box } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import { viewerBackground } from '@/theme/colors';

export const LoadingSpinnerContainer = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  height: calc(80vh / var(--zoom));
`;

export const ParentContainer = muiStyled(Box)<{ navbarHeight: number }>(({ navbarHeight }) => ({
  paddingTop: navbarHeight,
  position: 'relative',
  display: 'flex',
  flexDirection: 'row',
  height: 'calc(100vh / var(--zoom))',
  background: viewerBackground,
  overflow: 'hidden',
}));

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;
